import { render, staticRenderFns } from "./CandidateContactModal.vue?vue&type=template&id=1a74c230&"
import script from "./CandidateContactModal.vue?vue&type=script&lang=js&"
export * from "./CandidateContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports